import {onDomReady} from "../lib/on_dom_ready";

onDomReady(() => {
  const customExpiryDays = document.querySelector("#clinical_alert_config_expiry_days_custom");
  const otherExpiryDays = document.querySelector("#clinical_alert_config_expiry_days_other");

  if (!customExpiryDays || !otherExpiryDays) {
    return;
  }

  customExpiryDays.addEventListener("click", () => {
    otherExpiryDays.checked = true;
  });
});
